
import axios from 'axios';
import Vue from 'vue';
import config from './Herramientas/config';
import utilidades from './Herramientas/utilidades';
import Swal from 'sweetalert2';

export default Vue.extend({
  name: 'App',
  methods: {
    interceptor() {
      const interceptor = axios.interceptors.response.use(
        (response) => response,
        (error) => {
          if (error.response.status !== 401)
            return Promise.reject(error)

          axios.interceptors.response.eject(interceptor);

          return axios.get(`${config.URL_API}/${window.$rutas.rutaRenovacionToken}`, config.AXIOS_CONFIG(utilidades.decodificar(this.$cookies.get('datosUsuario'), config.qwerty()).Token))
            .then((response) => {
              const cookie = utilidades.decodificar(this.$cookies.get('datosUsuario'), config.qwerty())
              cookie.Token = response.data.Token

              const cookieEncrypted = utilidades.codificar(JSON.stringify(cookie), config.qwerty()).toString()
              this.$cookies.set('datosUsuario', cookieEncrypted)

              error.response.config.headers["Authorization"] = "Bearer " + response.data.Token;

              return axios(error.response.config);
            })
            .catch((error2) => {
              Swal.fire('Error', 'No se pudo renovar el Token', 'error')
                .then(() => {
                  this.$cookies.set('datosUsuario', '')
                  this.$router.push("/");
                  return Promise.reject(error2);
                })
            })
            .finally(this.interceptor);
        }
      )
    },
    decodeDataFromCookie(atributo: string) {
      return utilidades.decodificar(this.$cookies.get('datosUsuario'), config.qwerty())[atributo]
    }
  },
  created() {
    this.interceptor()
    var idioma = this.decodeDataFromCookie("Idioma");
    if(idioma != '' && idioma != null){
    this.$root.$i18n.locale = this.decodeDataFromCookie("Idioma").split("-")[0];
    } else {
      this.$root.$i18n.locale = 'es'
    }
  },
  data: () => ({
    //
  }),
});
